import { SearchCriteria } from "./search-criteria";

export class CheckGiftCardCodeSearchCriteria extends SearchCriteria {
    public GiftCardCode: string;

}
